import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { API_BASE_URL } from './lib/api';
import { useSession } from './session';

function useSignOut() {
  const { setSession } = useSession();
  const navigate = useNavigate();

  return useCallback(() => {
    fetch(`${API_BASE_URL}/auth/logout`, {
      method: 'POST',
      credentials: 'include'
    }).catch((error) => {
      console.warn('Failed to clear server session', error);
    });
    setSession(null);
    navigate('/login', { replace: true });
  }, [navigate, setSession]);
}

export { useSignOut };
